import { filterCategories } from 'src/common/boatCategories';

const mapCategoriesToGroupIds = (categories: string[]): string[] => Array.from(
  new Set(categories.flatMap((groupCatId) => filterCategories[groupCatId])),
);

export default mapCategoriesToGroupIds;
